import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { i18n } from "services/i18nService";
import { linkIntuitAccount } from "services/sosInventoryService/sosApi";

import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

import { INTUIT_AUTH_REDIRECT_URL } from "appConstants";

const DEFAULT_LINK_ERROR = i18n("quickBooks.ConnectError");

export function IntuitAuth() {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    function handleError(authError) {
      navigate("/configuration/connections/quickbooks", {
        state: { authError },
      });
    }

    async function _linkIntuitAccount(params) {
      dispatch(loadingIndicatorOn());
      try {
        const { success, message } = await linkIntuitAccount(params);
        if (success) {
          dispatch(loadingIndicatorOff());
          navigate("/configuration/connections/quickbooks");
        } else {
          handleError(message || DEFAULT_LINK_ERROR);
        }
        dispatch(loadingIndicatorOff());
      } catch (e) {
        dispatch(loadingIndicatorOff());
        handleError(DEFAULT_LINK_ERROR);
      }
    }
    const queryParams = new URLSearchParams(search);
    const localState = localStorage.getItem("qboState");
    const state = queryParams.get("state");
    const code = queryParams.get("code");
    const realmId = queryParams.get("realmId");

    if (state !== localState) {
      handleError(DEFAULT_LINK_ERROR);
    } else if (code && realmId) {
      _linkIntuitAccount({ code, realmId, redirect: INTUIT_AUTH_REDIRECT_URL });
    } else {
      handleError(DEFAULT_LINK_ERROR);
    }
  }, [navigate, search, pathname, dispatch]);

  return null;
}
